import { Component, OnInit } from '@angular/core';
import { GlobalesService } from 'src/app/servicios/globales.service';
import { ObtenerDatosService } from '../../../../servicios/datos/obtener-datos/obtener-datos.service';

import { ThemeService } from '../../../../theme/theme.service';

@Component({
  selector: 'app-pregunta-estadistica',
  templateUrl: './pregunta-estadistica.component.html',
  styleUrls: ['./pregunta-estadistica.component.scss']
})
export class PreguntaEstadisticaComponent implements OnInit {
  config:any = {};
  Search = "";
  respuestaDatosEspEnt = "";
  respuestaDatosEspDis = "";
  preguntaGrafica = "";

  constructor(public _globalService: GlobalesService,
    public readonly _obtenerDatosService: ObtenerDatosService,public themeService: ThemeService,) { }

  ngOnInit(): void {
    this._globalService.searchItem.subscribe(data =>{
      if(data == null) return;
      this.Search = data
    });

    this._obtenerDatosService.configSubject.subscribe(data =>{
      if (data != null) this.config = data;
      const mrLbl = !this.config.show_mr_label ? '' : ' MR';
      this.respuestaDatosEspEnt = `Se muestran los datos específicos:
        <br><br>
        Gráfico de las Actas Esperadas, Capturadas y Contabilizadas, el total por cada una y su porcentaje hasta el momento.
        <br><br>
        Lista Nominal, donde se explica:
        <br><br>
        El número de personas registradas en la Lista Nominal de las casillas con Actas Contabilizadas se utiliza para obtener el porcentaje de Participación ciudadana.
        <br><br>
        La fórmula para obtener el porcentaje de Participación Ciudadana; gráfico de la Lista Nominal de las casillas con Actas Contabilizadas en comparación con la Lista Nominal oficial.
        <br><br>
        También, se especifica que en el gráfico no se considera la cantidad de votos asentados en las Actas PREP de Casilla Especial.
        <br><br>
        El porcentaje de la Participación Ciudadana con base en la Lista Nominal de las casillas con Actas PREP Contabilizadas.
        <br><br>
        Gráfico de los votos en Casillas Básicas, Contiguas y Extraordinarias, así como en Casillas Especiales${mrLbl}.
        <br><br>
        Total de Votos, en cantidad.
        `;
      this.respuestaDatosEspDis = `Se muestran los datos específicos del Distrito consultado, representación gráfica de las
        Actas Esperadas, Capturadas y Contabilizadas, el total por cada una y su porcentaje hasta el momento.
        <br><br>
        Gráfico de la Lista Nominal de las casillas con Actas Contabilizadas en comparación con la Lista Nominal de Casillas Aprobadas.
        <br><br>
        El porcentaje de la Participación Ciudadana con base en la Lista Nominal de las casillas con Actas PREP Contabilizadas, considerando el porcentaje calculado de la votación en
        Casillas Especiales${mrLbl}.
        <br><br>
        Fórmula para obtener el porcentaje de la Participación Ciudadana.`;
      this.preguntaGrafica = `¿Qué indica la gráfica de Votos en Casillas Especiales${mrLbl}?`;
      
    });
  }

}
